import { memo, useCallback, useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
// import { loadAll } from "@tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
// import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.
import brand from "../brand";

const DynamicBackground = () => {
  const [init, setInit] = useState(false);

  // this should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
      // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
      // starting from v2 you can add only the features you need reducing the bundle size
      //await loadAll(engine);
      //await loadFull(engine);
      await loadSlim(engine);
      //await loadBasic(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = useCallback(() => {}, []);

  const options = useMemo(
    () => ({
      fullScreen: {
        enable: true,
        // 0, not -1: negative z-index has to win a race against every
        // ancestor's own painted background (html/body included) to stay
        // visible, and that's inconsistent across browsers/scroll states.
        // Page content already opts into z-index: 2, so 0 keeps particles
        // reliably sandwiched between the page background and the content.
        zIndex: 0,
      },
      background: {
        color: {
          value: brand.colorBg,
        },
        zIndex: 0,
        },
      fpsLimit: 144,
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: "push",
          },
          onHover: {
            enable: true,
            mode: "repulse",
          },
        },
        modes: {
          push: {
            quantity: 4,
          },
          repulse: {
            distance: 196,
            duration: 0.30,
          },
        },
      },
      particles: {
        color: {
          value: brand.colorAccent,
        },
        links: {
          color: brand.colorAccent,
          distance: 150,
          enable: true,
          opacity: 0.09,
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: 2,
          straight: false,
        },
        number: {
          density: {
            enable: true,
          },
          value: 80,
        },
        opacity: {
          value: 0.23,
          animation: {
            enable: true,
            speed: 0.3,
            minimumValue: 0.09,
            sync: false,
          },
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 6 },
        },
      },
      detectRetina: true,
    }),
    [],
  );

  if (init) {
    return (
      <Particles
        id="tsparticles"
        particlesLoaded={particlesLoaded}
        options={options}
      />
    );
  }

  return <></>;
};

// Memoized because @tsparticles/react's <Particles> effect depends on the
// whole props object it receives, not just the individual values inside it
// (see node_modules/@tsparticles/react/dist/Particles.js). That means any
// re-render of this component — even one that changes nothing tsparticles
// cares about — makes it tear down and rebuild the entire particle engine
// and canvas from scratch, which is what showed up as a ~1s freeze/flicker
// every time the page navigated (this component sits outside <Routes>, but
// every render pass still touched it). It only ever takes stable/no props,
// so memoizing it is a safe way to guarantee it never re-renders after the
// particles have loaded once.
export default memo(DynamicBackground);